import React from 'react';
import './NavItem.css'
import { Link, useRouteMatch } from "react-router-dom";

const classNames = require('classnames');

export function NavTitle1(props: {
    children: JSX.Element | Array<JSX.Element> | string
}) {
    return (
        <div className="nav-title1">
            {props.children}
        </div>
    )
}

export function NavTitle2(props: {
    children: JSX.Element | Array<JSX.Element> | string
}) {
    return (
        <div className="nav-title2">
            {props.children}
        </div>
    )

}


export default function NavItem(props: {
    children: JSX.Element | Array<JSX.Element> | string,
    to: string,
    activeOnlyWhenExact?: boolean
}) {
    let match = useRouteMatch({
        path: props.to,
        exact: props.activeOnlyWhenExact
    });
    return (
        <li className={classNames("nav-item", match ? "nav-item-choose" : "")}>
            <Link style={{ textDecoration: 'none' }} to={props.to}>
                {props.children}
            </Link>
        </li>
    )
}

export function NavItemLink(props: {
    children: JSX.Element | Array<JSX.Element> | string,
    to: string,
    activeOnlyWhenExact?: boolean
}) {
    let match = useRouteMatch({
        path: props.to,
        exact: props.activeOnlyWhenExact
    });
    return (
        <li className={classNames("nav-item", match ? "nav-item-choose" : "")}>
            <div
                style={{ textDecoration: 'none' }}
                onClick={() => {
                    window.open(props.to);
                }}
            >
                {props.children}
            </div>
        </li>
    )
}